import React from "react";

// Components
import Default from "./Default";


const Settings = () => {
    return (
        <Default />
    )
};

export default Settings;